import React from "react";
import { Cursor, useTypewriter } from "react-simple-typewriter";
import { FaLinkedin, FaInstagram, FaPhone } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import toast from "react-hot-toast";

const LeftAbout = () => {
  const [typeText] = useTypewriter({
    words: [
      "a Software Engineer.",
      "a Full Stack Developer.",
      "a Problem Solver.",
    ],
    loop: true,
    typeSpeed: 30,
    deleteSpeed: 30,
    delaySpeed: 2000,
  });

  const copyToClipboard = (event) => {
    event.preventDefault();
    const email = "anshuman0799@gmail.com";
    navigator.clipboard
      .writeText(email)
      .then(() => {
        toast.success("Email copied successfully :)", {
          style: {
            background: "#111827",
            color: "#e5e7eb",
          },
        });
      })
      .catch(() => {
        toast.success("Email copying failed", {
          style: {
            background: "#111827",
            color: "#e5e7eb",
          },
        });
      });
  };

  return (
    <div className="w-full xl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-6 lgl:gap-8">
        <h1 className="text-2xl md:text-3xl font-normal">Hey there!</h1>
        <h1 className="text-4xl md:text-6xl font-bold text-black">
          {" "}
          I'm <span className="text-designColor capitalize"> Anshuman </span>
        </h1>
        <h1 className="text-2xl md:text-3xl font-normal">
          <span> {typeText} </span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#2257bf"
          ></Cursor>
        </h1>
        <p className="text-sm md:text-base font-bodyFont leading-6 tracking-wide">
          I’m a Full-Stack Software Engineer with 4+ years of industry
          experience, building modern, scalable web applications from front to
          back.
          <br></br>
          <br></br>I work with technologies like React, TypeScript, Tailwind
          CSS, Spring Boot, AWS, and MongoDB to deliver fast, reliable, and
          user-focused solutions.
          <br></br>
          <br></br>
          Whether it’s crafting seamless UI experiences, developing secure APIs,
          or deploying to the cloud, I love turning ideas into production-ready
          products.
          <br></br>
        </p>
        <div className="flex flex-col justify-between">
          <div className="mr-auto pt-2">
            <div className="mr-auto pt-2">
              <button
                type="button"
                className="downloadButton"
                onClick={() =>
                  (window.location.href =
                    "https://drive.google.com/file/d/16GiIhE0bF-ZYZWWc9QBBE0fUUd62wCj5/view?usp=sharing")
                }
              >
                Download CV
              </button>
            </div>
          </div>
          <div className="mt-8">
            {" "}
            <h1 className="text-2xl text-designColor"> Connect with me! </h1>
            <div className="flex pt-6 gap-6 md:gap-0">
              <a
                href="https://www.linkedin.com/in/anshuman0799/"
                target="_blank"
                rel="noopener noreferrer"
                className="contactIcon"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://www.instagram.com/sh.human/"
                target="_blank"
                rel="noopener noreferrer"
                className="contactIcon"
              >
                <FaInstagram />
              </a>
              <a
                href="mailto:anshuman0799@gmail.com"
                onClick={copyToClipboard}
                className="contactIcon"
              >
                <IoMail />
              </a>
              <a href="tel:+14387781249" className="contactIcon">
                <FaPhone />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftAbout;
